import React from "react";
import OpnameWerkbon from "../OpnameWerkbon";

export default function MonteurOpnamesPage() {
  return <OpnameWerkbon />;
}
